import { render, staticRenderFns } from "./Conjunto.vue?vue&type=template&id=c8b880d6&lang=pug&"
import script from "./Conjunto.vue?vue&type=script&lang=js&"
export * from "./Conjunto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports